import type { UserProfileType } from "@src/types";
import { privateApi } from "./client";

export async function getProfileApi(signal?: AbortSignal): Promise<UserProfileType> {
    const { data } = await privateApi.get<UserProfileType>("/api/users/profile", {
        signal,
    });
    return data;
}
